/*
  Keyboard and screen-reader support for the mobile slideout menu.

  The <menu-slideout> element (menu-slideout.*.min.js, built from source that
  isn't in the theme) opens and closes by toggling data-active when the
  hamburger is clicked. This adds, on top of it:
  - the closed menu is inert, so its off-screen links aren't in the tab order
  - aria-expanded on the hamburger kept in sync with the open state
  - focus moves into the menu when it opens
  - Escape closes the menu and returns focus to the hamburger
*/
(function () {
  const FOCUSABLE = 'a[href], button:not([disabled]), summary, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])';

  function init() {
    const panel = document.querySelector('[data-menu-slideout]');
    const toggle = document.querySelector('[data-hamburger-menu]');
    if (!panel || !toggle || panel.dataset.a11yReady) return;
    panel.dataset.a11yReady = 'true';

    const isOpen = () => panel.hasAttribute('data-active');

    const sync = () => {
      const open = isOpen();
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        panel.removeAttribute('inert');
        const first = panel.querySelector(FOCUSABLE);
        if (first && !panel.contains(document.activeElement)) first.focus({ preventScroll: true });
      } else {
        if (panel.contains(document.activeElement)) toggle.focus();
        panel.setAttribute('inert', '');
      }
    };

    // Set here rather than in the markup, so the menu still works if this script fails to load
    if (!isOpen()) panel.setAttribute('inert', '');
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['data-active'] });
    sync();

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !isOpen()) return;
      event.preventDefault();
      // Close through the existing toggle so the component resets its own state
      toggle.click();
      toggle.focus();
    });
  }

  customElements.whenDefined('menu-slideout').then(() => requestAnimationFrame(init));
})();
